import userApi from 'apis/userApi';
import { RootState, useAppSelector } from 'cache/store';
import DatePicker from 'components/date-picker/DatePicker';
import LoadingIcon from 'components/loading/LoadingIcon';
import Modal from 'components/modal/Modal';
import globalStyle from 'constants/global.style';
import { NewListStastRespone } from 'models/statisticModel';
import moment from 'moment';
import { useState } from 'react';
import toast from 'react-hot-toast';
import accountStyles from './account-option.style';
import StatsAgencyDetail from './StatsAgencyDetail';
import { css } from '@emotion/css';

const actionType = [
    { value: 0, label: 'Đặt cược từ lớn tới nhỏ' },
    { value: 1, label: 'Chiết khấu từ lớn tới nhỏ' },
    { value: 2, label: 'Trúng cược từ lớn tới nhỏ' },
    { value: 3, label: 'Khuyến mãi từ lớn tới nhỏ' },
    { value: 4, label: 'Nạp tiền từ lớn tới nhỏ' },
    { value: 5, label: 'Rút tiền từ lớn tới nhỏ' },
];

function StatsAgency() {
    const { agentType } = useAppSelector((state: RootState) => state.auth);

    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')}`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')}`));
    const [orderSelect, setOrderSelect] = useState(0);
    const [loginname, setLoginName] = useState('');
    const [recordList, setRecordList] = useState<NewListStastRespone[] | null>(null);
    const [mainRecord, setMainRecord] = useState<NewListStastRespone | null>(null);
    const [totalRecord, setTotalRecord] = useState<NewListStastRespone | null>(null);
    const [loading, setLoading] = useState(false);

    const [recordDetail, setRecordDetail] = useState<any>(null);

    const searchStats = async () => {
        if (!startTime || !endTime) {
            toast.error('Ngày chọn không hợp lệ');
            return;
        }
        setLoading(true);
        const payload = {
            order: orderSelect,
            loginname,
            stime: moment(startTime).format('yyyy-MM-DD'),
            etime: moment(endTime).format('yyyy-MM-DD'),
        };
        try {
            const { data } = await userApi.reportWinLossSearch(payload);
            if (!data.msg) {
                setRecordList(data.reportmain);
                setMainRecord(data.ruitem);
                setTotalRecord(data.totallist);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className={`${accountStyles.wrap}`}>
                <div className={accountStyles.mw800}>
                    <h6 className={accountStyles.title}>Báo Cáo Đại Lý</h6>
                    <div className={accountStyles.flexbox}>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={accountStyles.wrapInput}>
                                <DatePicker dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} showIcon maxDate={new Date()} />
                            </div>
                        </div>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Đến</label>
                            <div className={accountStyles.wrapInput}>
                                <DatePicker dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} showIcon maxDate={new Date()} />
                            </div>
                        </div>
                        <div className={`${accountStyles.flex50} ${accountStyles.groupInput}`}>
                            <label htmlFor="">Loại</label>
                            <div className={accountStyles.wrapInput}>
                                <select className="input-common" value={orderSelect} onChange={(e) => setOrderSelect(Number(e.target.value))}>
                                    {actionType.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className={`${accountStyles.groupInput} ${accountStyles.flex50}`}>
                            <label htmlFor="">Tên Tài Khoản</label>
                            <div className={accountStyles.wrapInput}>
                                <input value={loginname} onChange={(e) => setLoginName(e.target.value)} className="input-common" type="text" placeholder="Tên tài khoản" />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.elmSubmit}`}>
                        <button type="button" className={`btn-primary ${accountStyles.btnSubmit}`} onClick={searchStats}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>
                <div className="table-common">
                    {recordList ? (
                    <>
                            {mainRecord && (
                                <div className="col-table">
                                    <div className="col-header">
                                        <p>{mainRecord.loginname}</p>
                                        <span>Khuyến mãi: <strong>{new Intl.NumberFormat().format(mainRecord.bonus)}</strong></span>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>Nạp tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(mainRecord.dp)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Rút tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(mainRecord.wd)}</strong>
                                        </div>
                                        {agentType === 1 && (
                                            <>
                                                <div className="col">
                                                    <p>Nạp tiền cấp dưới:</p>
                                                    <strong>{new Intl.NumberFormat().format(mainRecord.sjdp)}</strong>
                                                </div>
                                                <div className="col">
                                                    <p>Rút tiền cấp dưới</p>
                                                    <strong>{new Intl.NumberFormat().format(mainRecord.wdagent)}</strong>
                                                </div>
                                            </>
                                        )}
                                        <div className="col">
                                            <p>Cược:</p>
                                            <strong>{new Intl.NumberFormat().format(mainRecord.tz)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Chiết khấu:</p>
                                            <strong>{new Intl.NumberFormat().format(mainRecord.fd)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Trúng:</p>
                                            <strong className={`${mainRecord.saletz >= 0 ? 'text-success' : 'text-error'}`}>{new Intl.NumberFormat().format(mainRecord.win)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Lợi nhuận:</p>
                                            <strong>{new Intl.NumberFormat().format(mainRecord.saletz)}</strong>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {recordList.map((item, index) => (
                                <div className="col-table">
                                    <div className="col-header">
                                        <p>{item.loginname}</p>
                                        <span>Khuyến mãi: <strong>{new Intl.NumberFormat().format(item.bonus)}</strong></span>
                                    </div>
                                    <div className="row" key={index}>
                                        <div className="col">
                                            <p>Nạp tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(item.dp)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Rút tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(item.wd)}</strong>
                                        </div>
                                        {agentType === 1 && (
                                            <>
                                                <div className="col">
                                                    <p>Nạp tiền cấp dưới:</p>
                                                    <strong>{new Intl.NumberFormat().format(item.dpxj)}</strong>
                                                </div>
                                                <div className="col">
                                                    <p>Rút tiền cấp dưới</p>
                                                    <strong>{new Intl.NumberFormat().format(item.wdchild)}</strong>
                                                </div>
                                            </>
                                        )}
                                        <div className="col">
                                            <p>Cược:</p>
                                            <strong>{new Intl.NumberFormat().format(item.tz)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Chiết khấu:</p>
                                            <strong>{new Intl.NumberFormat().format(item.fd)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Trúng:</p>
                                            <strong className={`${item.saletz >= 0 ? 'text-success' : 'text-error'}`}>{new Intl.NumberFormat().format(item.win)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Lợi nhuận:</p>
                                            <strong>{new Intl.NumberFormat().format(item.saletz)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Xem:</p>
                                            <span className="btn-detail" onClick={() => setRecordDetail(item)}>
                                                Chi tiết
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {totalRecord && (
                                <div className="col-table">
                                    <div className="col-header">
                                        <p>Tổng cộng</p>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <p>Nạp tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(totalRecord.dp)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Rút tiền:</p>
                                            <strong>{new Intl.NumberFormat().format(totalRecord.wd)}</strong>
                                        </div>
                                        {agentType === 1 && (
                                            <>
                                                <div className="col">
                                                    <p>Nạp tiền cấp dưới:</p>
                                                    <strong>{new Intl.NumberFormat().format(totalRecord.sjdp)}</strong>
                                                </div>
                                                <div className="col">
                                                    <p>Rút tiền cấp dưới</p>
                                                    <strong>{new Intl.NumberFormat().format(totalRecord.wdagent)}</strong>
                                                </div>
                                            </>
                                        )}
                                        <div className="col">
                                            <p>Cược:</p>
                                            <strong>{new Intl.NumberFormat().format(totalRecord.tz)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Chiết khấu:</p>
                                            <strong>{new Intl.NumberFormat().format(totalRecord.fd)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Trúng:</p>
                                            <strong className={`${totalRecord.saletz >= 0 ? 'text-success' : 'text-error'}`}>{new Intl.NumberFormat().format(totalRecord.win)}</strong>
                                        </div>
                                        <div className="col">
                                            <p>Lợi nhuận:</p>
                                            <strong>{new Intl.NumberFormat().format(totalRecord.saletz)}</strong>
                                        </div>
                                        {/* <div className="col">
                                            <p>Xem:</p>
                                            <span className="btn-detail" onClick={() => setRecordDetail(item)}>
                                                Chi tiết
                                            </span>
                                        </div> */}
                                    </div>
                                </div>
                            )}
                    </>
                    ) : (
                        <div className="no-data"></div>
                    )}
                </div>
            </div>
            <Modal isShow={Boolean(recordDetail)} onClose={() => setRecordDetail(null)} closeClickBackdrop>
                <StatsAgencyDetail statsData={recordDetail} onClose={() => setRecordDetail(null)} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    elmSubmit: css`
        max-width: 40%;
        margin: 15px auto;
    `,
};

export default StatsAgency;
